import { useEffect, useState } from 'react'

import { MaxViewPage } from 'tools/Uniform'
import { readableError } from 'utils/error'
import { loadingBabble } from 'utils/loadingBabble'

export function useWait(timeout) {
  const [wait, setWait] = useState(!!timeout)

  // don't show it unless we are taking more than 1 second
  useEffect(() => {
    let isMounted = true
    if (wait) {
      setTimeout(() => {
        if (isMounted) {
          setWait(false)
        }
      }, timeout)
    }

    // return the function to "unmount"
    return () => {
      isMounted = false
    }
  }, [wait, setWait, timeout])

  return wait
}

// like Loading, but use children instead of the loading function
export function WaitThen({ wait = 1000, spinner = 0, children }) {
  if (useWait(wait)) {
    if (spinner) return <LoadingSpinner />
    return null
  }
  return children
}

export function LoadingTop(args) {
  return (
    <div className="relative w-100">
      <div className="absolute top-0 mt2 w-100">
        <Loading className="flex-center w-100 gh2" {...args} />
      </div>
    </div>
  )
}

export function LoadingCenter(args) {
  return (
    <div className="flex-center h-100 v-100">
      <Loading {...args} />
    </div>
  )
}

export default function Loading({ wait = 1000, ...args }) {
  if (useWait(wait)) return null
  return <LoadingSpinner {...args} />
}

export function LoadingSpinner({
  className = 'flex-items gh2',
  children,
  babble = true
}) {
  return (
    <div className={className}>
      <div className="loading-inline" />
      {children}
      {children && babble && ': '}
      {babble && loadingBabble()}
    </div>
  )
}

// for when loading may take longer
export function LoadingOverlay({ children, onlyFull, noText = false }) {
  const [showFull, updateShowFull] = useState(false)
  const [retries, updateRetries] = useState(0)
  let showText = [
    <div key="1">
      {children || loadingBabble()}
      {retries ? ' (retry ' + retries + ')' : null}
    </div>
  ]
  if (noText) {
    showText = []
  }

  // DOC: this effect tracks a mount/unmount flag, so it does not update
  // state if the component is not active (mounted)
  useEffect(() => {
    let isMounted = true
    setTimeout(() => {
      if (isMounted) {
        updateShowFull(true)
      }
    }, 300)
    setTimeout(() => {
      if (isMounted) {
        updateShowFull(false)
        updateRetries(retries + 1)
      }
    }, 10000)

    // return the function to "unmount"
    return () => {
      isMounted = false
    }
  })

  if (showFull) {
    return (
      <div className="loading-overlay">
        <div className="loading"></div>
        <div className="tc pv2 pv4-m pv6-l white">{showText}</div>
        <div className="loading-body"></div>
      </div>
    )
  } else {
    if (onlyFull) {
      return <></>
    }
    return (
      <div className="flex">
        {showText}
        <div className="loading-inline" />
      </div>
    )
  }
}

export function LoadingNope({ children, show, mesg }) {
  const [viz, setViz] = useState(false)

  useEffect(() => {
    let isMounted = true
    setTimeout(() => {
      if (isMounted && !show) {
        setViz(true)
      }
    }, 1000)

    return () => {
      isMounted = false
    }
  })

  if (show) return children
  if (viz)
    return (
      <MaxViewPage>
        <div className="flex-center">{mesg}</div>
      </MaxViewPage>
    )
  return null
}

export function ErrorBox({ children }) {
  return (
    <div className="flex justify-center red b">{readableError(children)}</div>
  )
}

export { readableError, Loading }
